import { ChevronRight, Equal, Minus, Plus } from "lucide-react";
import { fmtIDR } from "../lib/format";
import { cn } from "./ui";
import type { WfStep } from "./Waterfall";

export function FormulaStrip({ steps, active, onPick }: { steps: WfStep[]; active?: string; onPick: (k: string) => void }) {
  return (
    <div className="flex flex-wrap items-stretch gap-2" data-testid="cashflow-formula">
      {steps.map((s, i) => (
        <div key={s.key} className="flex items-center gap-2">
          {i > 0 && <span className="text-muted-foreground">{s.kind === "end" ? <Equal className="h-4 w-4" /> : s.kind === "minus" ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}</span>}
          <button type="button" onClick={() => onPick(s.key)} data-testid={`cashflow-step-${s.key}`}
            className={cn("group min-w-[136px] rounded-lg border px-3 py-2 text-left transition-colors hover:border-primary/60",
              s.kind === "start" && "bg-slate-50 dark:bg-slate-900/40 border-slate-300",
              s.kind === "plus" && "bg-emerald-50 dark:bg-emerald-950/30 border-emerald-300",
              s.kind === "minus" && "bg-red-50 dark:bg-red-950/30 border-red-300",
              s.kind === "end" && "bg-sky-50 dark:bg-sky-950/30 border-sky-300",
              active === s.key && "ring-2 ring-primary")}>
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground flex items-center justify-between">{s.label}<ChevronRight className="h-3 w-3 opacity-0 group-hover:opacity-100" /></div>
            <div className={cn("num text-sm font-bold", s.kind === "plus" && "text-emerald-700", s.kind === "minus" && "text-red-600", s.kind === "end" && "text-sky-700")}>{s.kind === "minus" && s.value ? "−" : ""}{fmtIDR(s.value)}</div>
          </button>
        </div>
      ))}
    </div>
  );
}
